import styled from 'styled-components';
import { SomaDrawerContent } from '@soma/react';

export const Container = styled(SomaDrawerContent)`
  width: 360px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;

  .soma-subtitle {
    color: #000;
    font-weight: 500;
  }
`;

export const Item = styled.div`
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;

export const SliderContainer = styled.div`
  overflow-y: scroll;
  padding-right: 10px;
  height: 87vh;

  &::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar
  {
    width: 6px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    background-color: #3f4044;
  }
`;
